var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { BehaviorSubject } from 'rxjs';
import { CybersourceModalService } from '@ibe.services/cybersource-modal.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
// import { INDRABookingPaymentPageComponent } from '../booking-payment-page/booking-payment-page.indra.component';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Router } from '@angular/router';
import { PAYMENT_FLOW_MYB, PAYMENT_FLOW_BOOKING, PAYMENT_CARDHOLDER_TRAVELLING, PAYMENT_CARDHOLDER_NOT_TRAVELLING, PAYMENT_NOTIFICATION_ERROR_CODE_DECLINED_CC_VALIDATION } from '@ibe.config';
var INDRACybersourceModalComponent = /** @class */ (function (_super) {
    __extends(INDRACybersourceModalComponent, _super);
    function INDRACybersourceModalComponent(modalService, cybersourceModalService, storage, paymentService, router) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.cybersourceModalService = cybersourceModalService;
        _this.storage = storage;
        _this.paymentService = paymentService;
        _this.router = router;
        _this.currentDataPay = new BehaviorSubject(_this.dataPay);
        _this.msgTwo = false;
        _this.msgOne = false;
        _this.acceptButtonEnabled = true;
        _this.isBookingFlow = false;
        _this.allSubscriptions = [];
        _this.TYPE = 'dialog';
        return _this;
    }
    INDRACybersourceModalComponent.prototype.ngOnInit = function () {
        this.INDRA_fraudMessage();
    };
    /**
     * NOTE: booking-payment-page component must subscribe to cybersourceModalService to prevent circular dependecies
     * Parameters being passed to modal:
     *	(0) dataPay
     *	(1) idOperation
     * 	(2) fraud message code (MSG1 or MSG2)
     *	(3) card number
     *	(4) payment flow (PAYMENT_FLOW_MYB, or PAYMENT_FLOW_BOOKING)
     */
    INDRACybersourceModalComponent.prototype.INDRA_cyberSourceAccept = function () {
        var _this = this;
        var dataPayment = this.modalService.params[0];
        var idOperation = this.modalService.params[1];
        var fraudType = this.modalService.params[2];
        this.isBookingFlow = true;
        // const component:INDRABookingPaymentPageComponent = this.modalService.params[3]; 
        // const card_number: string = this.modalService.params[4];
        this.acceptButtonEnabled = false;
        this.cybersourceModalService.sendDataPayment(dataPayment, idOperation, fraudType);
        this.cyberSourceModalSubscription = this.cybersourceModalService.getObject().subscribe(function (res) {
            _this.closeModal();
        });
    };
    INDRACybersourceModalComponent.prototype.INDRA_cyberSourceReject = function () {
        // const component: INDRABookingPaymentPageComponent = this.modalService.params[3];
        var pnr = this.modalService.params[0].pnr;
        var lastname = this.storage.get('lastname');
        var paymentFlow = this.modalService.params[4];
        this.closeModal();
        // note: no redirection needed for Normal IBE booking and TTT payment flow
        if (paymentFlow === PAYMENT_FLOW_MYB) {
            this.router.navigate(['/my-bookings/details', pnr, lastname]);
        }
        else if (paymentFlow === PAYMENT_FLOW_BOOKING) {
            var request = {
                sessionId: this.storage.get('token'),
                pnr: pnr,
                idOperation: this.modalService.params[1],
                typeError: PAYMENT_NOTIFICATION_ERROR_CODE_DECLINED_CC_VALIDATION
            };
            this.paymentService.INDRA_declinedValidation(request);
            this.router.navigate(['/']);
        }
    };
    INDRACybersourceModalComponent.prototype.INDRA_fraudMessage = function () {
        var message = this.modalService.params[2];
        if (message === PAYMENT_CARDHOLDER_TRAVELLING) {
            this.msgOne = true;
        }
        else if (message === PAYMENT_CARDHOLDER_NOT_TRAVELLING) {
            this.msgTwo = true;
        }
    };
    INDRACybersourceModalComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    INDRACybersourceModalComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    return INDRACybersourceModalComponent;
}(AbstractModalContentComponent));
export { INDRACybersourceModalComponent };
